"use strict";
export const VDListMock = (mock) => {
  mock.onGet("/v1/virtual-desktops").reply((cofig) => {
    console.log(cofig);
    let _response = {
      "model": "grid.result",
      "result": {
        "model": "data.set",
        "datas": [
          {
            "id": "",
            "oldId": "",
            "name": "\u6D4B\u8BD5VD",
            "address": "127.0.2.1",
            "expiredTime": 1718941731,
            "autoRenew": true,
            "type": "selfConfigure",
            "status": "wait",
            "canUseSeconds": 1e5,
            "price": 69,
            "currency": "CNY",
            "shops": {
              "total": 5,
              "datas": [{
                "id": "",
                "name": "\u6D4B\u8BD5\u5E97\u94FA",
                "logo": "http://xxxxxx/sssss"
              }]
            },
            "region": {
              "id": "",
              "name": ""
            },
            "marks": {
              "tags": [
                ""
              ]
            }
          },
          {
            "id": "",
            "oldId": "",
            "name": "\u6D4B\u8BD5VD",
            "address": "127.0.2.1",
            "expiredTime": 1718941731,
            "autoRenew": true,
            "type": "selfConfigure",
            "status": "wait",
            "canUseSeconds": 1e5,
            "price": 69,
            "currency": "CNY",
            "shops": {
              "total": 5,
              "datas": [{
                "id": "",
                "name": "\u6D4B\u8BD5\u5E97\u94FA",
                "logo": "http://xxxxxx/sssss"
              }]
            },
            "region": {
              "id": "",
              "name": ""
            },
            "marks": {
              "tags": [
                ""
              ]
            }
          },
          {
            "id": "",
            "oldId": "",
            "name": "\u6D4B\u8BD5VD",
            "address": "127.0.2.1",
            "expiredTime": 1718941731,
            "autoRenew": true,
            "type": "selfConfigure",
            "status": "wait",
            "canUseSeconds": 1e5,
            "price": 69,
            "currency": "CNY",
            "shops": {
              "total": 5,
              "datas": [{
                "id": "",
                "name": "\u6D4B\u8BD5\u5E97\u94FA",
                "logo": "http://xxxxxx/sssss"
              }]
            },
            "region": {
              "id": "",
              "name": ""
            },
            "marks": {
              "tags": [
                ""
              ]
            }
          }
        ],
        "total": 4
      },
      "page": {
        "model": "page",
        "current": 1,
        "total": 4,
        "size": 10
      }
    };
    return [200, _response];
  });
};
